export function GetDomain() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
}